import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {fetchActivitiesIfNeeded, fetchMenusIfNeeded,
  selectSection, fetchSectionsIfNeeded, selectAZ} from '../../actions'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import {MovieItem} from '../MoviesView/MovieItem'
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {FooterNote} from '../FooterLinks/FooterNote'

export class ActivityGalleryView extends React.Component {
  constructor (props) {
    super(props)
    this.toMap = this.toMap.bind(this)
    this.renderMovieItems = this.renderMovieItems.bind(this)
    this.onSectionClick = this.onSectionClick.bind(this)
    this.toggleAZorder = this.toggleAZorder.bind(this)
    this.onClickTagLabel = this.onClickTagLabel.bind(this)
  }

  componentDidMount () {
    const {dispatch} = this.props
    dispatch(fetchActivitiesIfNeeded())
    dispatch(fetchMenusIfNeeded(this.props.selectedScope))
    dispatch(fetchSectionsIfNeeded('activities'))
  }

  componentWillReceiveProps (nextProps) {
    const { selectedScope, dispatch } = nextProps

    if (selectedScope !== this.props.selectedScope) {
      dispatch(fetchMenusIfNeeded(selectedScope))
    }

    dispatch(fetchSectionsIfNeeded('activities'))
  }

  toMap (obj) {
    return Object.keys(obj).map((key) => [key, obj[key]])
  }

  renderMovieItems (movies) {
    const m = this.toMap(movies)
    return (
      m.map((movie, i) => {
        <MovieItem movie={movie} onClickTagLabel={this.onClickTagLabel} key={i} />
      })
    )
  }

  renderSections () {
    const {sections, selectedSection} = this.props
    return (
      <DropdownButton noCaret ref='mydropdown' className='section-list' title={selectedSection}
        id='bg-justified-dropdown'>
      {sections.map((section, i) => {
        return (
          <MenuItem key={i} data-tag={section.name} onClick={this.onSectionClick} eventKey={i}>{section.name}</MenuItem>
        )
      })}
      </DropdownButton>
    )
  }

  onSectionClick (e) {
    e.preventDefault()
    e.stopPropagation()
    this.props.dispatch(selectSection(e.target.getAttribute('data-tag')))
  }

  toggleAZorder (e) {
    e.preventDefault()
    e.stopPropagation()
    const orderByNameState = e.target.classList.contains('active-gallery') ? 0 : 1
    this.props.dispatch(selectAZ(orderByNameState))
  }

  renderMovies () {
    const {activities, isFetchingActivities, selectedSection} = this.props
    let filt_activities = activities
    if (typeof selectedSection !== 'undefined' && selectedSection !== 'SECÇÕES') {
      filt_activities = activities.filter((movie) => {
        return movie.name === selectedSection
      })
    }

    if (isFetchingActivities && filt_activities.length === 0) {
      const loadmessage = (isFetchingActivities) ? 'A carregar conteúdos...' : 'Não existem eventos paralelos'
      return (
        <h4 style={{color: '#ccc'}}>{loadmessage}</h4>
      )
    }

    if (!isFetchingActivities && filt_activities.length === 0) {
      return (
        <h4 style={{color: '#ccc'}}>Não existem eventos paralelos associadas a "{selectedSection}"</h4>
      )
    }

    if (this.props.selectedAZ === 1) {
      const orderedActivities = filt_activities.sort(this.compare)
      return (
        orderedActivities.map((movie, i) => {
          return (
            <MovieItem type='activity' grid_size={4} onClickTagLabel={this.onClickTagLabel} movie={movie} key={i} />
          )
        })
      )
    } else {
      return (
        filt_activities.map((movie, i) => {
          return (
            <MovieItem type='activity' grid_size={4} onClickTagLabel={this.onClickTagLabel} movie={movie} key={i} />
          )
        })
      )
    }
  }

  compare (a, b) {
    if (a.title < b.title) {
      return -1
    } else if (a.title > b.title) {
      return 1
    } else {
      return 0
    }
  }

  onClickTagLabel (tagname) {
    console.log('tagName', tagname)
  }

  render () {
    const {menus, selectedAZ, isFetchingActivities, dispatch} = this.props
    // const num_movies = Object.keys(movies).length
    const top_menus = menus.top || []
    const bottom_menus = menus.bottom || []
    const orderByNameClass = selectedAZ === 1 ? 'active-gallery' : ''

    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='movies-view' className='row m-gallery'>
          <div className='col-md-12'>
            <p className='section-title'>EVENTOS PARALELOS</p>
          </div>
          <div className='grid-header'>
            <p>Filtrar por</p>
            <div>
              {this.renderSections()}
              <button onClick={this.toggleAZorder} className={orderByNameClass}>FILMES A a Z</button>
            </div>
          </div>
          <div className='feedback'>
            <div id='movie-list' className='col-xs-12 no-pad'
              style={{ opacity: isFetchingActivities ? 0.5 : 1 }}>
              {this.renderMovies()}
            </div>
          </div>
        </div>
        <FooterLinks bottom_menus={bottom_menus}/>
        <FooterNote />
      </div>
    )
  }
}

ActivityGalleryView.propTypes = {
  dispatch: PropTypes.func.isRequired,
  activities: PropTypes.array.isRequired,
  menus: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ]).isRequired,
  selectedSection: PropTypes.string.isRequired,
  isFetchingActivities: PropTypes.bool.isRequired,
  sections: PropTypes.array.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  selectedScope: PropTypes.string.isRequired
}

function mapStateToProps (state) {
  const {getActivities, getMenus, getSections, selectedSection,
          selectedAZ, selectedScope} = state
  const {
    isFetchingActivities,
    items: activities
  } = getActivities['all'] || {
    isFetching: true,
    items: []
  }

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: {}
  }

  const {
    isFetchingSections,
    items: sections
  } = getSections[`activities_${selectedScope}`] || {
    isFetchingSections: true,
    items: []
  }

  return {
    activities,
    isFetchingActivities,
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    selectedSection,
    sections,
    isFetchingSections,
    selectedScope,
    selectedAZ
  }
}

export default connect(mapStateToProps)(ActivityGalleryView)



// WEBPACK FOOTER //
// ./src/views/ActivitiesView/ActivityGalleryView.js